import { get, set, del, keys } from 'idb-keyval';
import { imageUploadsStore } from '../db/database.js';

const PREFIX = 'pending-img:';

class OfflineImageUploadService {
  async _ensureStoreReady() {
    try {
      await imageUploadsStore('ready');
    } catch {
    }
  }

  async enqueue(id, blob, metadata = {}) {
    const entry = {
      id,
      blob,
      metadata: {
        originalName: metadata.originalName || 'image.webp',
        size: blob.size,
        timestamp: Date.now(),
        ...metadata,
      },
      createdAt: Date.now(),
      status: 'pending',
    };
    await set(`${PREFIX}${id}`, entry, imageUploadsStore);
    return id;
  }

  async getPending() {
    const allKeys = await keys(imageUploadsStore);
    const uploadKeys = allKeys.filter(k => k.startsWith(PREFIX));
    const entries = [];
    for (const key of uploadKeys) {
      try {
        const entry = await get(key, imageUploadsStore);
        if (entry) entries.push(entry);
      } catch {
      }
    }
    return entries;
  }

  async remove(id) {
    await del(`${PREFIX}${id}`, imageUploadsStore);
  }

  async getCount() {
    const allKeys = await keys(imageUploadsStore);
    return allKeys.filter(k => k.startsWith(PREFIX)).length;
  }

  async getAllImageRefs() {
    const entries = await this.getPending();
    return entries.map(e => `offline://pending-img/${e.id}`);
  }
}

export const offlineImageUploadService = new OfflineImageUploadService();
